export const transactionStatus = {
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  CANCELED: 'CANCELED'
}

export const timeZones = {
  kinshasa: 'Africa/Kinshasa',
  accra: 'Africa/Accra'
}

export const roles = {
  SuperMerchant: 'SuperMerchant'
}

export const proxyPayDataTypes = {
  subscribers: 'subscribers',
  transactions: 'transactions',
  volumes: 'volumes',
  revenues: 'revenues',
  opex: 'opex',
  ebitda: 'ebitda'
}

export const SITE_KEY = '6LfK1CUaAAAAAPogOw89QtsBfRoJl40XmigN4xnf'
